// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dd-selector[data-v-185a054c]{position:relative}.dd-selector .dd-selector__select[data-v-185a054c]{position:absolute;top:0;right:0;bottom:0;left:0;opacity:0;z-index:1}@media (min-width:960px){.dd-selector:hover .b.b-arrow-down[data-v-185a054c]:after{opacity:.1}}", ""]);
// Exports
module.exports = exports;
